export default __webpack_public_path__ + "static/media/bur1.b45462c3.jpeg";